/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import BasicLogic from "./basicLogic";
import { globalVar } from "../../utils/globalVar";

const { JUSTICE_PUBLISHER_NAMESPACE } = globalVar;

export default new BasicLogic({ namespace: JUSTICE_PUBLISHER_NAMESPACE });
